// reduces size by hundreds of bytes gzipped...
module.exports = x => x.length
